import { apiRequest } from "./apiClient";

export const getAllTemplates = async () => {
  return await apiRequest({ method: "GET", endpoint: "/templates" });
};

export const saveTemplate = async (payload) => {
  return await apiRequest({ method: "POST", endpoint: "/templates", body: payload });
};

export const deleteTemplate = async (templateId) => {
  return await apiRequest({ method: "GET", endpoint: `/templates/${templateId}` });
};
